import { TextField } from '@warp-ds/react';
import { connect } from 'react-redux';
import { BasicDatePicker } from 'shared/components/basicDatePicker/BasicDatePicker';
import { addMonths, safeFormatISODate, safeParseISO } from 'shared/util/datetime-fns';
import type { ApiQueryParams, FlexibleDate, PaleState } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import { actions as filterActions } from '@/state/filterActions';
import { FlexibleDateHandler } from './FlexibleDateHandler';

export interface Props {
    departureDate?: FlexibleDate;
    returnDate?: FlexibleDate;
    changeDepartureDate: (date: string | null) => void;
    changeReturnDate: (date: string | null) => void;
    changeFlexibleDeparture: (flex: number) => void;
    changeFlexibleReturn: (flex: number) => void;
    triggerFetch: (queryParam?: ApiQueryParams) => void;
}

export const DatePicker = ({
    departureDate = {},
    returnDate = {},
    changeDepartureDate,
    changeReturnDate,
    changeFlexibleDeparture,
    changeFlexibleReturn,
    triggerFetch,
}: Props) => {
    const changeDatesAndFetch = ({ startDate, endDate }: { startDate: Date | null; endDate: Date | null }): void => {
        changeDepartureDate(safeFormatISODate(startDate));
        changeReturnDate(safeFormatISODate(endDate));
        triggerFetch();
    };
    const changeFlexibility = (flex: string): void => {
        changeFlexibleDeparture(~~flex);
        changeFlexibleReturn(~~flex);
        triggerFetch();
    };

    return (
        <>
            <BasicDatePicker
                onDateChange={(dates) => changeDatesAndFetch(dates)}
                startDate={safeParseISO(departureDate.date)}
                endDate={safeParseISO(returnDate.date)}
                useRange={true}
                visibleMonths={2}
                upperDateLimit={addMonths(12, new Date())}>
                <TextField id="date-range-start" label="Avreisedato" />
                <TextField id="date-range-end" label="Hjemreisedato" />
            </BasicDatePicker>
            <FlexibleDateHandler
                options={displayValues.flexibilityOptions}
                selected={departureDate.flexibility || 0}
                onChange={changeFlexibility}
            />
        </>
    );
};

const mapStateToProps = (state: PaleState): Pick<Props, 'departureDate' | 'returnDate'> => ({
    departureDate: state.filters.departureDate,
    returnDate: state.filters.returnDate,
});

const mapDispatchToProps = {
    changeDepartureDate: filterActions.changeDepartureDate,
    changeReturnDate: filterActions.changeReturnDate,
    resetDepartureDate: filterActions.changeDepartureDate,
    resetReturnDate: filterActions.changeReturnDate,
    changeFlexibleDeparture: filterActions.changeFlexibleDeparture,
    changeFlexibleReturn: filterActions.changeFlexibleReturn,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatePicker);
